export default __webpack_public_path__ + "static/media/CustomIngredient.058f5abc.jpg";